import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import clsx from 'clsx'
import Sidebar from './Sidebar'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { useAppStore } from '@/store'
import { useBrand } from '@/branding/useBrand'

const IconMenu = () => (
  <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round">
    <path d="M3 5h14M3 10h14M3 15h14"/>
  </svg>
)

export default function DashboardLayout() {
  const { isMobile } = useBreakpoint()
  const { dark, sidebarCollapsed, setSidebarCollapsed } = useAppStore()
  const brand = useBrand()
  // La ficha técnica (/bom) es full-bleed: gestiona su propio padding interno.
  const fullBleed = useLocation().pathname.startsWith('/bom')

  useEffect(() => {
    if (isMobile) setSidebarCollapsed(true)
  }, [isMobile, setSidebarCollapsed])

  return (
    <div className={`flex h-screen overflow-hidden ${dark ? 'bg-slate-950' : 'bg-brand-bg'}`}>
      {isMobile && (
        <header className="fixed top-0 left-0 right-0 z-40 flex items-center gap-3 px-4 h-14 bg-brand-dark border-b border-white/10">
          <button
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            className="text-white/70 hover:text-white transition-colors p-1 -ml-1"
            aria-label="Abrir menú"
          >
            <IconMenu />
          </button>
          <div className="flex items-center gap-2">
            <img
              src={brand.logoOnDark}
              alt={brand.name}
              className="h-6 w-auto object-contain"
              style={brand.invertLogoOnDark ? { filter: 'invert(1)' } : undefined}
            />
            <span className="text-[12px] font-semibold text-white tracking-wide">{brand.chromeLabel} Factory</span>
          </div>
        </header>
      )}

      {isMobile && !sidebarCollapsed && (
        <div
          className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm plan-overlay-enter"
          onClick={() => setSidebarCollapsed(true)}
          aria-hidden="true"
        />
      )}

      <Sidebar />

      <main className={clsx(
        'flex-1 overflow-y-auto scroll-thin',
        fullBleed
          ? (isMobile ? 'pt-14' : '')
          : (isMobile ? 'pt-14 px-3 pb-3' : 'p-6'),
      )}>
        <Outlet />
      </main>
    </div>
  )
}
